import React from 'react';

import "./Services.scss";
import { Article } from '../../elements/Article/Article';


export const Services = ()=>{
    return (
        <section className="Services">
            <Article className="block wall" src="web-services" level={0}/>
        </section>
    )
}

export default Services;
